import { IColumnDefinition } from 'features/Lists/core/contracts/IColumnDefinition'

enum ColumnIdsEnum {
  id = 'id',
  source = 'source',
  oms = 'oms',
  accountNo = 'accountNo',
  bloombergId = 'bloombergId',
  uniqueIdentifier = 'uniqueIdentifier',
  identifier = 'identifier',
  breakDesc = 'breakDesc',
  dataAction = 'dataAction',
  summaryStatus = 'summaryStatus',
  noOfBreaks = 'noOfBreaks',
  aimStrategyCode = 'aimStrategyCode',
  aimQuantity = 'aimQuantity',
  aimMarketValue = 'aimMarketValue',
  performStrategyCode = 'performStrategyCode',
  performQuantity = 'performQuantity',
  performMarketValue = 'performMarketValue',
  seiStrategyCode = 'seiStrategyCode',
  seiMarketValue = 'seiMarketValue',
  seiQuantity = 'seiQuantity',
  reconDate = 'reconDate',
  reconAge = 'reconAge',
  breakSummaryDetails = 'breakSummaryDetails',
  breakDetailStatus = 'breakDetailStatus',
  lastUpdatedAt = 'lastUpdatedAt',
  cusip = 'cusip',
  isin = 'isin',
  sedol = 'sedol',
  ticker = 'ticker',
  securityDescription = 'securityDescription',
  investmentType = 'investmentType',
  bbgglobalId = 'bbgglobalId',
  comments = 'comments'
}

export const SEIColumnIds = { ...ColumnIdsEnum }
export type SEIColumnIds = typeof SEIColumnIds

export const SEIColumnDefinitions: Record<string, IColumnDefinition> = {
  [SEIColumnIds.id]: {
    id: SEIColumnIds.id,
    name: ' ',
    type: 'string',
    width: 30,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'id',
    selectable: false,
    hidden: true
  },
  [SEIColumnIds.source]: {
    id: SEIColumnIds.source,
    name: 'Source',
    type: 'string',
    width: 80,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'source',
    selectable: false
  },
  [SEIColumnIds.accountNo]: {
    id: SEIColumnIds.accountNo,
    name: 'Account Number',
    type: 'string',
    width: 220,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'accountNo',
    selectable: false
  },
  [SEIColumnIds.bloombergId]: {
    id: SEIColumnIds.bloombergId,
    name: 'Bloomberg ID',
    type: 'string',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'bloombergId',
    selectable: false
  },
  [SEIColumnIds.uniqueIdentifier]: {
    id: SEIColumnIds.uniqueIdentifier,
    name: 'Bloomberg Unique Identifier',
    type: 'string',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'uniqueIdentifier',
    selectable: false
  },
  [SEIColumnIds.identifier]: {
    id: SEIColumnIds.identifier,
    name: 'Identifier',
    type: 'string',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'identifier',
    selectable: false
  },
  [SEIColumnIds.oms]: {
    id: SEIColumnIds.oms,
    name: 'OMS',
    type: 'string',
    width: 80,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'oms',
    selectable: false
  },
  [SEIColumnIds.dataAction]: {
    id: SEIColumnIds.dataAction,
    name: 'Actions',
    type: 'custom',
    width: 90,
    filterable: false,
    sortable: false,
    searchable: false,
    facetable: false,
    dataPath: 'id',
    selectable: false
  },
  [SEIColumnIds.breakDesc]: {
    id: SEIColumnIds.breakDesc,
    name: 'Break Description',
    type: 'string',
    width: 350,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'breakDesc'
  },
  [SEIColumnIds.noOfBreaks]: {
    id: SEIColumnIds.noOfBreaks,
    name: 'Number of Breaks',
    type: 'number',
    width: 100,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: true,
    dataPath: 'noOfBreaks',
    className: 'USDColumn'
  },
  [SEIColumnIds.reconAge]: {
    id: SEIColumnIds.reconAge,
    name: 'Recon Age',
    type: 'number',
    width: 100,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: true,
    dataPath: 'reconAge',
    className: 'USDColumn'
  },
  [SEIColumnIds.seiStrategyCode]: {
    id: SEIColumnIds.seiStrategyCode,
    name: 'SEI Strategy Code',
    type: 'string',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'seiStrategyCode'
  },
  [SEIColumnIds.seiMarketValue]: {
    id: SEIColumnIds.seiMarketValue,
    name: 'SEI Market Value',
    type: 'number',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: true,
    dataPath: 'seiMarketValue',
    className: 'USDColumn'
  },
  [SEIColumnIds.seiQuantity]: {
    id: SEIColumnIds.seiQuantity,
    name: 'SEI Quantity',
    type: 'number',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: true,
    dataPath: 'seiQuantity',
    className: 'USDColumn'
  },
  [SEIColumnIds.performStrategyCode]: {
    id: SEIColumnIds.performStrategyCode,
    name: 'Perform Strategy Code',
    type: 'string',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'performStrategyCode'
  },
  [SEIColumnIds.performMarketValue]: {
    id: SEIColumnIds.performMarketValue,
    name: 'Perform Market Value',
    type: 'number',
    width: 180,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: true,
    dataPath: 'performMarketValue',
    className: 'USDColumn'
  },
  [SEIColumnIds.performQuantity]: {
    id: SEIColumnIds.performQuantity,
    name: 'Perform Quantity',
    type: 'number',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: true,
    dataPath: 'performQuantity',
    className: 'USDColumn'
  },
  [SEIColumnIds.aimStrategyCode]: {
    id: SEIColumnIds.aimStrategyCode,
    name: 'AIM Strategy Code',
    type: 'string',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'aimStrategyCode'
  },
  [SEIColumnIds.aimMarketValue]: {
    id: SEIColumnIds.aimMarketValue,
    name: 'AIM Market Value',
    type: 'number',
    width: 200,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: true,
    dataPath: 'aimMarketValue',
    className: 'USDColumn'
  },
  [SEIColumnIds.aimQuantity]: {
    id: SEIColumnIds.aimQuantity,
    name: 'AIM Quantity',
    type: 'number',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: true,
    dataPath: 'aimQuantity',
    className: 'USDColumn'
  },
  [SEIColumnIds.breakSummaryDetails]: {
    id: SEIColumnIds.breakSummaryDetails,
    name: ' ',
    type: 'custom',
    width: 250,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'breakSummaryDetails',
    selectable: false,
    hidden: true
  },
  [SEIColumnIds.breakDetailStatus]: {
    id: SEIColumnIds.breakDetailStatus,
    name: 'Break Status',
    type: 'string',
    width: 1,
    filterable: true,
    sortable: false,
    searchable: false,
    facetable: true,
    dataPath: 'detailStatus',
    collectionPath: 'breakSummaryDetails',
    selectable: false,
    hidden: true
  },
  [SEIColumnIds.summaryStatus]: {
    id: SEIColumnIds.summaryStatus,
    name: 'Summary Status',
    type: 'string',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'summaryStatus'
  },
  [SEIColumnIds.cusip]: {
    id: SEIColumnIds.cusip,
    name: 'CUSIP',
    type: 'string',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'cusip'
  },
  [SEIColumnIds.isin]: {
    id: SEIColumnIds.isin,
    name: 'ISIN',
    type: 'string',
    width: 120,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'isin'
  },
  [SEIColumnIds.sedol]: {
    id: SEIColumnIds.sedol,
    name: 'SEDOL',
    type: 'string',
    width: 100,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'sedol'
  },
  [SEIColumnIds.ticker]: {
    id: SEIColumnIds.ticker,
    name: 'Ticker',
    type: 'string',
    width: 100,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'ticker'
  },
  [SEIColumnIds.securityDescription]: {
    id: SEIColumnIds.securityDescription,
    name: 'Security Description',
    type: 'string',
    width: 200,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'securityDescription'
  },
  [SEIColumnIds.investmentType]: {
    id: SEIColumnIds.investmentType,
    name: 'Investment Type',
    type: 'string',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'investmentType'
  },
  [SEIColumnIds.bbgglobalId]: {
    id: SEIColumnIds.bbgglobalId,
    name: 'BBG Global ID',
    type: 'string',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: true,
    dataPath: 'bbgglobalId'
  },
  [SEIColumnIds.comments]: {
    id: SEIColumnIds.comments,
    name: 'Comments',
    type: 'string',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: true,
    facetable: false,
    dataPath: 'comments'
  },
  [SEIColumnIds.lastUpdatedAt]: {
    id: SEIColumnIds.lastUpdatedAt,
    name: 'Last Update Date',
    type: 'date',
    width: 150,
    filterable: true,
    sortable: true,
    searchable: false,
    facetable: false,
    dataPath: 'lastUpdatedAt'
  }
}

export const SEIDefaultColumns: ColumnIdsEnum[] = [
  ColumnIdsEnum.id,
  ColumnIdsEnum.accountNo,
  ColumnIdsEnum.bloombergId,
  ColumnIdsEnum.identifier,
  ColumnIdsEnum.oms,
  ColumnIdsEnum.dataAction,
  ColumnIdsEnum.breakDesc,
  ColumnIdsEnum.securityDescription,
  ColumnIdsEnum.investmentType,
  ColumnIdsEnum.noOfBreaks,
  ColumnIdsEnum.reconAge,
  ColumnIdsEnum.seiMarketValue,
  ColumnIdsEnum.performMarketValue,
  ColumnIdsEnum.aimMarketValue,
  ColumnIdsEnum.seiQuantity,
  ColumnIdsEnum.performQuantity,
  ColumnIdsEnum.aimQuantity,
  ColumnIdsEnum.seiStrategyCode,
  ColumnIdsEnum.performStrategyCode,
  ColumnIdsEnum.aimStrategyCode,
  ColumnIdsEnum.cusip,
  ColumnIdsEnum.isin,
  ColumnIdsEnum.sedol,
  ColumnIdsEnum.ticker,
  ColumnIdsEnum.bbgglobalId,
  ColumnIdsEnum.uniqueIdentifier,
  ColumnIdsEnum.summaryStatus,
  ColumnIdsEnum.source,
  ColumnIdsEnum.comments,
  ColumnIdsEnum.breakSummaryDetails,
  ColumnIdsEnum.lastUpdatedAt
]
